<template>
  <v-container
    ref="container"
    class="overflow-y-auto pa-0 border-top"
  >
    <v-row
      v-for="(item,index) in items"
      :key="item.raw.accountBranchId"
    >
      <branch-item-simple-card
        :item="item"
        @pick="pick => $emit('pick', pick)"
      />
    </v-row>
  </v-container>
</template>

<script>
    import BranchItemSimpleCard from "@/components/items/branch/BranchItemSimpleCard";

    export default {
        name: "BranchListItemSimpleCard",
        components: {BranchItemSimpleCard},
        props: {
            items: {
                type: Array,
                default: () => [],
            },
        },
        methods: {}
    }
</script>

<style scoped>

</style>